import { Suspense, useEffect, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Outlet, useLocation } from 'react-router-dom';

import { Spinner } from 'library/components/controls/loaders/Spinner';
import { AdobeTrackingProvider } from 'library/components/track/AdobeTrackingProvider';
import { setHistory } from 'library/redux/application';
import { useAppDispatch } from 'library/redux/hooks';
import { SnackbarWrapper } from 'library/snackbar/SnackbarWrapper';
import { MsalProvider, isVppnAsync } from 'main/auth/provider';
import { ErrorFallback } from 'main/errors/ErrorFallback';
import Layout from 'main/layout/Layout';

import { ClientSideNavigation } from './ClientSideNavigation';

const RootAuthentication = () => {
	const location = useLocation();

	const dispatch = useAppDispatch();

	useEffect(() => {
		dispatch(setHistory(location));
	}, [dispatch, location]);

	const [isVppn, setIsVppn] = useState<boolean | undefined>(undefined);

	useEffect(() => {
		isVppnAsync().then(setIsVppn);
	}, []);

	if (isVppn === undefined) {
		return <></>;
	}

	// ErrorBoundary and Layout needs token for API calls
	const layout = (
		<AdobeTrackingProvider>
			<Layout>
				<ErrorBoundary FallbackComponent={ErrorFallback}>
					<SnackbarWrapper>
						{/* a temp solution is to add a key to Suspense to work with RRD v7*/}
						<Suspense
							fallback={<Spinner />}
							key="root-authentication">
							<Outlet />
						</Suspense>
					</SnackbarWrapper>
				</ErrorBoundary>
			</Layout>
		</AdobeTrackingProvider>
	);

	if (isVppn == true) {
		return layout;
	} else {
		return (
			<ClientSideNavigation instance={MsalProvider.msalInstance}>
				{layout}
			</ClientSideNavigation>
		);
	}
};

export default RootAuthentication;
